import { Box } from '@mantine/core';
import { ContractsList } from 'components/ContractsList';
import { ContractsListMobile2 } from 'components/ContractsListMobile2';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { useGetWorkerContractsQuery } from 'redux/Api/contractsApi/contractsApi';
import { Text } from '@mantine/core';
import styles from './EmployedsProfileContent.module.scss';
import { useEffect } from 'react';
import { ContractsListMobile } from 'components/ContractsListMobile';
import { useMediaQuery } from '@mantine/hooks';

export const ContractsProfileContent = ({
  worker,
  sendDataToParent,
}: {
  worker: any;
  sendDataToParent: any;
}) => {
  const { data, isLoading: isContractsLoading } = useGetWorkerContractsQuery(worker?.id);

  const isMobileAndTablet = useMediaQuery('(width < 1679px)');
  const isLargeScreen = useMediaQuery('(width >= 1679px)');

  useEffect(() => {
    if (isContractsLoading) {
      sendDataToParent(0);
      return;
    }

    if (!data?.data || !Array.isArray(data.data)) {
      sendDataToParent(0);
      return;
    }

    const res = data.data.filter(
      (el: any) => el.status === 'signed_by_worker' || el.status === 'signed_by_customer',
    );

    sendDataToParent(res.length > 0);
  }, [data, isContractsLoading, sendDataToParent]);

  return isContractsLoading ? (
    <LoadingSkeleton />
  ) : data?.data?.length ? (
    <>
      {isMobileAndTablet && (
        <Box>
          <div className={styles.customContractMobile}>
            <ContractsListMobile2
              intersectionComponent={null}
              data={data?.data}
              key={data?.meta?.total}
            />
          </div>
        </Box>
      )}
      {isLargeScreen && (
        <Box>
          <div className={styles.customContractTable}>
            <ContractsList
              intersectionComponent={null}
              data={data?.data}
              key={data?.meta?.total}
              hidePerformer={true}
            />
          </div>
        </Box>
      )}
    </>
  ) : (
    <Text lh='22px' c='#71869D' fz='16px'>
      Нет действующего договора с исполнителем
    </Text>
  );
};
